<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Carrinho" />
  <menuLateral />
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="mb-5">
        <Progresso ref="progresso" @atualizarStatus="atualizarProgresso" :status="progresso"/>
        <div class="row" v-if="ehCarrinho">
          <div class="col-md-8 col-12">
            <ItensCarrinho ref="itensCarrinho" />
          </div>
          <div class="col-md-4 col-12 mb-2">
            <CodigoPromocional @atualizarPrecos="atualizarPrecos" />
            <Resumo ref="resumoCarrinho" v-if="itensPedidos.length > 0" :pedidos="[]" :itens_proporcional="[]">
              <template #total>
                <div class="mt-2">
                  <span class="card-text text-muted">Itens</span>
                  <span class="card-text text-bold float-right">{{formatarValorMonetario(obterValorTotalCarrinho)}}</span>
                </div>
              </template>
            </Resumo>
            <Total ref="totalComponente" :total="obterValorTotalCarrinho"/>
            <div class="row" v-if="!temPagamentoPendente">
              <div class="col-6">
                <button class="botoes btn btn-secondary btn-md btn-block" @click="voltarParaMercado">Voltar ao mercado</button>
              </div>
              <div class="col-6">
                <button v-if="ehProdutoMirt" class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="trocarDePlano()">Trocar Plano</button>
                <button v-else class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="contratar()">Contratar</button>
              </div>
            </div>
            <div class="row" v-if="temPagamentoPendente">
              <div class="col-12">
                <button v-if="ehProdutoMirt" class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="trocarDePlano()">Trocar Plano</button>
                <button v-else class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="contratar()">Contratar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Plano adicional -->
        <div class="row" v-else>
          <div class="col-md-8 col-12">
            <DadosEscritorio ref="dadosEscritorio" v-show="ehConfirmacaoDados" :escritorio="dadosFormulario.escritorio"/>
            <Pagamento ref="pagamento" v-show="ehPagamento" @atualizarId="atualizarId" :dadosCartao="dadosFormulario.escritorio.cartao" :dadosPagamento="dadosFormulario.forma_pagamento"/>
          </div>
          <div class="col-md-4 col-12 mb-2">
            <CodigoPromocional />
            <Resumo v-if="itensPedidos.length > 0" ref="resumo" :pedidos="itensPedidos" :itens_proporcional="itensProporcional" :total="obterValorTotal" :dataVencimento="detalhesFatura.data_vencimento" :cupom_selecionado="cupom_selecionado"/>
            <Total ref="totalComponente" v-if="itensPedidos.length > 0" :total="obterValorTotal" :pedidos="itensPedidos" :cupom_selecionado="cupom_selecionado"/>
            <div v-else class="spinner mt-2 mb-2">
              <!-- Spinner de carregamento -->
              <div class="spinner-border" role="status">
                <span class="sr-only">Carregando...</span>
              </div>
            </div>
            <div class="row" v-if="!temPagamentoPendente">
              <div class="col-6">
                <button class="botoes btn btn-secondary btn-md btn-block" @click="voltarParaMercado">Voltar ao mercado</button>
              </div>
              <div class="col-6">
                <button v-if="ehPagamento" ref="efetuarPagamento" class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="efetuarPagamento()">Pagar</button>
                <button v-else class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status || !podePagar" @click="avancar()">Avançar</button>
              </div>
            </div>
            <div class="row" v-if="temPagamentoPendente">
              <div class="col-12">
                <button v-if="ehPagamento" ref="efetuarPagamento" class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status" @click="efetuarPagamento()">Pagar</button>
                <button v-else class="botoes btn btn-azul btn-md btn-block" :disabled="flagsDeControle.carregandoDados.status || !podePagar" @click="avancar()">Avançar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="modal">
      <template #modal-header>
        <h5 class="modal-title">Pagamento</h5>
        <div>
          <button @click="voltar" class="close" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
    </template>
      <!-- Conteúdo do modal de sucesso -->
      <div class="row">
        <div class="col-12 text-center">
          <p v-if="this.erroPagamento">
            {{ this.mensagem }}
          </p>

          <p v-if="!this.erroPagamento">
            {{ this.mensagem }}
          </p>
          <b-spinner v-if="loading" label="Carregando..."></b-spinner>
        </div>
      </div>
      <template #modal-footer>
        <div>
          <button @click="voltar" class="btn btn-azul btn m-1">Voltar</button>
        </div>
      </template>
    </b-modal>
  </div>
  <!-- /.content-wrapper -->
</div>
<!-- ./wrapper -->
</template>

<script>
import Carrinho from './js'
export default Carrinho
</script>
